import { useRef, useEffect } from 'react';

const useIsMounted = () => {
	const isMounted = useRef<boolean>();
	useEffect(() => {
		isMounted.current = true;
		return () => {
			isMounted.current = false;
		};
	}, []);

	return isMounted;
};

export default useIsMounted;
